import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import React from "react";

interface KpiProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: KpiState;
    settings: any;
}

export class KpiComponent extends React.Component<KpiProps, any>{
    public static get NAME(): string { return "KPI"; }
    private kpiStateWrapper: KpiState;

    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.kpiStateWrapper = new KpiState();
        this.kpiStateWrapper.hydrateFromJS(props.settings);
    }

    handleDataChanged = (allData) => {
        if (this.kpiStateWrapper.dataSource) {
            let result = allData[this.kpiStateWrapper.dataSource.getDataSourceIdentifier() + this.props.uid];
            if (!result) {
                result = allData[this.kpiStateWrapper.dataSource.getDataSourceIdentifier()];
            }

            if (result && result.Data) {
                this.setState({ value: result.Data[0], allRows: result.Data });
            }
        }
    }

    registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
        this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
    }

    UNSAFE_componentWillMount() {
        this.registerComponent(this.props.uid, null, [this.kpiStateWrapper.dataSource]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const oldDataSourceId = !this.kpiStateWrapper.dataSource ? null : this.kpiStateWrapper.dataSource.getDataSourceIdentifier();

        this.kpiStateWrapper.hydrateFromJS(nextProps.settings);

        if (this.kpiStateWrapper.dataSource && this.kpiStateWrapper.dataSource.getDataSourceIdentifier() != oldDataSourceId) {

            this.registerComponent(nextProps.uid, null, [this.kpiStateWrapper.dataSource]);
            this.props.context.loadMissingData(this.props.queryParameter);
        }
    }

    componentWillUnmount() {
        this.props.context.unregisterComponent(this.props.uid);
    }
    render() {
        var value: any = '-.-';
        var text: any = '-.-';
        if (this.state.value) {
            value = [this.state.value[this.props.settings.valueField]];
            text = this.props.settings.textField;
        }
        return <react_components.ReactColumn width={this.props.metadataSettings.width}>
            <div className="small-box" style={{ backgroundColor: this.props.settings.color }}>
                <div className="inner">
                    <p>{text}</p>
                    <h3>{value}</h3>
                </div>
            </div>
        </react_components.ReactColumn>
    }
};


export class KpiState extends propertyTypes.BaseComponentProps {
    private textFieldMetadata = new propertyTypes.TranslatableTextProperty("textField", "Text field");
    public textField: string;

    private valueFieldMetadata = new propertyTypes.ColumnProperty("valueField", "Value field", "dataSource");
    public valueField: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color");
    public color: string;


    public dataSource: datasources.Datasource;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.textFieldMetadata, this.valueFieldMetadata, this.colorMetadata, datasources.dataSourceMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}

export class RdlTextCellPropsextends extends propertyTypes.BaseComponentProps {
    private textMetadata = new propertyTypes.TranslatableTextProperty("text", "Text");
    public text: string;

    private leftBorderMetadata = new propertyTypes.CheckBoxProperty("leftBorder", "Left border");
    public leftBorder: string;

    private topBorderMetadata = new propertyTypes.CheckBoxProperty("topBorder", "Top border");
    public topBorder: string;

    private rigthBorderMetadata = new propertyTypes.CheckBoxProperty("rightBorder", "Right border");
    public rightBorder: string;

    private bottomBorderMetadata = new propertyTypes.CheckBoxProperty("bottomBorder", "Bottom border");
    public bottomBorder: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color", false);
    public color: string;

    private boldMetadata = new propertyTypes.CheckBoxProperty("bold", "Bold");
    public bold: string;

    private textAlignMetadata = new propertyTypes.SelectProperty("textAlign", "Alignment")
        .addOption("0", "Left")
        .addOption("1", "Right")
        .addOption("2", "Center")
        .addOption("2", "General");
    public textAlign: string;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.textMetadata, this.leftBorderMetadata, this.topBorderMetadata, this.rigthBorderMetadata, this.bottomBorderMetadata, this.colorMetadata,
        this.boldMetadata, this.textAlignMetadata
        ]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}